import React, { useEffect } from "react";
import { useCurrentApplication } from "../../../Context/CurrentApplicationContext/CurrentApplicationContext";
import { InterviewSchedule } from "../../../Entities/interview-schedule.entity";
import JobApplicationService from "../../../Services/job.application.service";
import InterviewService from "../../../Services/interview.service";
import { useLoader } from "../../../Context/LoaderContext/LoaderContext";
import { formatDateTime } from "../../../Utils/generic-functions";
import { Button, Card, Divider, Tooltip, Typography } from "antd";
import { ClockCircleOutlined, VideoCameraOutlined } from "@ant-design/icons";
import Meta from "antd/es/card/Meta";
import Participants from "./Participants";

const ScheduleDetails = () => {
  const {
    jobPost,
    jobApplication,
    interviewSchedule,
    setInterviewSchedule,
    setJobApplication,
  } = useCurrentApplication();

  const { setLoading, setLoadingMessage, clearLoader } = useLoader();
  const jobApplicationService = new JobApplicationService();
  const interviewService = new InterviewService();

  const checkSchedule = async (
    applicationId: string,
  ): Promise<InterviewSchedule> => {
    return new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        try {
          const schedule =
            await interviewService.getOnlineInterviewDetails(applicationId);
          if (schedule.length > 0 && schedule[0] && schedule[0].conferenceId) {
            clearInterval(interval);
            resolve(schedule[0]);
          }
        } catch (error) {
          clearInterval(interval);
          reject(error);
        }
      }, 2000);
    });
  };

  const init = async () => {
    try {
      if (!jobApplication || !jobPost || !interviewSchedule) {
        return;
      }

      const isConferenceIdAdded = !!interviewSchedule.conferenceId;

      if (isConferenceIdAdded) {
        return;
      } else {
        setLoading(true);
        setLoadingMessage("Genarating a meeting link...");
        const updatedSchedule = await checkSchedule(jobApplication._id);
        const updatedApplication =
          await jobApplicationService.findJobApplicationById(
            jobApplication._id,
          );
        setInterviewSchedule(updatedSchedule);
        if (updatedApplication) {
          setJobApplication(updatedApplication);
        }
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      clearLoader();
    }
  };

  useEffect(() => {
    init();
  }, [interviewSchedule]);

  if (!jobApplication || !jobPost || !interviewSchedule) {
    return null;
  }

  const { startTime, endTime, conferenceId } = interviewSchedule;
  return (
    <div className="schedule-section">
      <section className="job-posts-details__section">
        <div className="job-posts-details__section-title">
          <span className="job-posts-details__section-bar" />
          <Typography.Title level={5} style={{ margin: 0 }}>
            Time Duration (1 hour)
          </Typography.Title>
        </div>
        <Typography.Paragraph style={{ margin: 0 }}>
          <ClockCircleOutlined /> {formatDateTime(startTime)} -{" "}
          {formatDateTime(endTime)}
        </Typography.Paragraph>
      </section>

      <section className="job-posts-details__section">
        <div className="job-posts-details__section-title">
          <span className="job-posts-details__section-bar" />
          <Typography.Title level={5} style={{ margin: 0 }}>
            Meeting Link
          </Typography.Title>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography.Link
            href={`https://meet.google.com/${conferenceId}`}
            target="_blank"
            rel="noreferrer"
            type={new Date(endTime) < new Date() ? "danger" : undefined}
            disabled={new Date(endTime) < new Date()}
          >
            {new Date(endTime) < new Date() ? (
              <Tooltip placement="topRight" title="Link is expired!">
                <span>{`https://meet.google.com/${conferenceId}`}</span>
              </Tooltip>
            ) : (
              <span>{`https://meet.google.com/${conferenceId}`}</span>
            )}
          </Typography.Link>
          <Button
            type="primary"
            onClick={() =>
              window.open(`https://meet.google.com/${conferenceId}`, "_blank")
            }
            disabled={new Date(endTime) < new Date()}
            icon={<VideoCameraOutlined />}
            iconPosition="end"
          >
            Join Interview
          </Button>
        </div>
      </section>

      <section className="job-posts-details__section">
        <div className="job-posts-details__section-title">
          <span className="job-posts-details__section-bar" />
          <Typography.Title level={5} style={{ margin: 0 }}>
            Participants
          </Typography.Title>
        </div>
        <Participants schedule={interviewSchedule} />
      </section>
    </div>
  );
};

export default ScheduleDetails;
